module.exports = __webpack_public_path__ + "img/faq_default.4cc71344.png";